var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status"},[_c('div',{staticClass:"state",class:("state--" + _vm.state)},[_c('div'),_c('div'),_c('div')]),_vm._v("\n\n\t"+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }